import { BrowserRouter, Routes, Route } from "react-router-dom";
import Body from "./components/Body";
import Login from "./components/Login";
import MaterialList from "./components/MaterialList";
import { Provider } from "react-redux";
import store from "./utils/appStore";
import Formulation from "./components/Formulation";
import FormulationDetail from "./components/FormulationDetail";

function App() {


  return (
    <>
      <Provider store={store}>
        <BrowserRouter basename="/">
          <Routes>
            <Route path="/" element={<Body />}>
              <Route path="/login" element={<Login />}></Route>
              <Route path="/materialList" element={<MaterialList />}>
              </Route>
              <Route path="/formulation" element={<Formulation />}>
               <Route
                  path="formulationDetail"
                  element={<FormulationDetail />}
                />
                <Route
                  path="formulationDetail/:id"
                  element={<FormulationDetail />}
                />
              </Route>
             
            </Route>
          </Routes>
        </BrowserRouter>
      </Provider>
    </>
  );
}





export default App;
